import { Button } from '@/components/ui/button';
import {
  FinanceManagerSelector,
  type FinanceManagerSelectorProps,
} from './finance-manager-selector';

export function FinanceManagerSelectorButton(
  props: FinanceManagerSelectorProps,
) {
  return (
    <Button variant="outline" className="p-0 h-fit">
      <FinanceManagerSelector {...props} />
    </Button>
  );
}
